import React from 'react';
import styles from './SpinnerButton.module.css';
import classNames from 'classnames';
import { Spinner } from 'react-bootstrap';

const SpinnerButton = ({
    spinning, // boolean controlled by parent, probably as part of the submit/continue/clickHandler function
    onClick, // handler
    text, // text to populate button
    styleType = 'primary', // supports 'primary' or 'secondary'
    className = '', // for custom classes or "utility" classes like margin and padding
    disabled = false, // boolean
    htmlType = 'button' // supports 'button,' 'submit' etc.
}) => {
    // stores global class from passed 'type' string
    const buttonClass = {
        primary: 'btn-primary',
        secondary: 'btn-secondary'
    };

    // Signal to developer if incorrect button type was passed.
    if (!buttonClass[styleType]) return <div>{'Developer Error :( Invalid Button Type'}</div>;

    return (
        <button
            className={classNames('btn', buttonClass[styleType], styles.relative, className)}
            onClick={onClick}
            disabled={disabled}
            type={htmlType}
        >
            {spinning && (
                <span className={styles.loader}>
                    <Spinner
                        color='light'
                        size='sm'
                        animation={spinning && 'border'}
                    />
                </span>
            )}
            <span className={spinning && styles.hideText}>{text}</span>
        </button>
    );
};

export default SpinnerButton;
